const initialState = {
};

const signReducer = (state = initialState, action) => {
    switch(action.type) {

        case 'RESET_AUTH' : {
            return {}
        }break;
        case 'SIGNIN_START' : {
            return {
                signIn : {
                }
            }
        }break;
        case 'SIGNIN_SUCCESS' : {
            return {
                signIn : {
                    success : true,
                }
            }
        }break;
        case 'SIGNIN_FAIL' : {
            return {
                signIn : {
                    success : false,
                    message : action.payload.message
                }
            }
        }break;
        case 'SIGNUP_START' : {
            return {
                signUp : {
                }
            }
        }break;
        case 'SIGNUP_SUCCESS' : {
            return {
                signUp : {
                    success : true
                }
            }
        }break;
        case 'SIGNUP_FAIL' : {
            return {
                signUp : {
                    success : false,
                    message : action.payload.message
                }
            }
        }break;
        case 'RESET_PASSWORD_SEND_START' : {
            return {
                resetPassword : {
                }
            }
        }break;
        case 'RESET_PASSWORD_SEND_SUCCESS' : {
            return {
                resetPassword : {
                    success : true
                }
            }
        }break;
        case 'RESET_PASSWORD_SEND_FAIL' : {
            return {
                resetPassword : {
                    success : false,
                    message : action.payload.message
                }
            }
        }break;
        case 'LOGGED_OUT' : {
            return {
            }
        }break;

        default : {
            return state;
        }break;
    }
}

export default signReducer;


// WEBPACK FOOTER //
// ./src/reducers/signReducer.js